@if ({
  page: page$ | async,
  productList: productList$ | async,
  hasProduct: hasProduct$ | async,
  isLoading: isLoading$ | async,
  }; as content) {
  @if (!content.isLoading && !content.hasProduct) {
    <div class="simple-card m-t-20 p-tb-40 content">
      <p class="h3 text-center">
        {{ 'category.noContent' | cxTranslate }}
      </p>
      <a [routerLink]="['/']" routerLinkActive="router-link-active" class="btn btn-outline-primary m-t-20 w-fit-i d-block">
        {{ 'generic.goHome' | cxTranslate }}
      </a>
    </div>
  }
}
